import Spacer from "@/components/atoms/spacer";
import Description from "./description";
import TitleContainer from "./titleContainer";
import PointList from "./pointList";
import RectangleButton from "@/components/molecules/rectangleButton";
import { getFileAsset } from "@sanity/asset-utils";
import { clientFetch } from "@/sanity/lib/client";

const Content = ({ title, icon, description, points, ctaButton }) => {
  return (
    <div className="relative w-full px-smallMobile md:px-mediumDesktop">
      <div className="relative w-full max-w-1440 mx-auto flex flex-col lg:flex-row justify-between items-center lg:items-start gap-y-mediumMobile lg:gap-x-smallDesktop mt-smallMobile lg:mt-mediumDesktop">
        <TitleContainer title={title} icon={icon} />
        <div className="relative w-full max-w-[620px] flex flex-col gap-y-smallMobile lg:gap-y-smallDesktop">
          <Description text={description} />
          <Spacer />
          <PointList points={points} />
          <RectangleButton
            name={ctaButton.name}
            link={
              ctaButton.option === "link"
                ? ctaButton.link
                : getFileAsset(ctaButton.pdf, clientFetch.config()).url
            }
            target="_blank"
            className="mx-auto lg:m-0"
          />
        </div>
      </div>
    </div>
  );
};

export default Content;
